import React, { CSSProperties } from 'react';
import { Card, Statistic } from 'antd';
import {
    BranchesOutlined,
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    DownloadOutlined,
    InboxOutlined,
    SwapOutlined,
    UploadOutlined,
} from '@ant-design/icons';
import InvoicingDashBoardStatsCardScss from './eimDashboardStatsCard.module.scss';

const getIconElement = (icon: string, style: CSSProperties): React.ReactNode => {
    switch (icon) {
        case 'inbox':
            return <InboxOutlined style={style} />;
        case 'download':
            return <DownloadOutlined style={style} />;
        case 'upload':
            return <UploadOutlined style={style} />;
        case 'check-circle':
            return <CheckCircleOutlined style={style} />;
        case 'close-circle':
            return <CloseCircleOutlined style={style} />;
        case 'swap':
            return <SwapOutlined style={style} />;
        case 'clock-circle':
            return <ClockCircleOutlined style={style} />;
        case 'branches':
            return <BranchesOutlined style={style} />;
        default:
            return undefined;
    }
};

interface IProps {
    data: any;
    icon: any;
    style: CSSProperties;
    darkMode?: boolean;
}

export default class EimDashboardStatsCard extends React.Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    public setTileData(data) {
        window.sessionStorage.setItem('type', data.type);
    }

    public render() {
        const { style, icon, data, darkMode } = this.props;
        const cardClasses = [InvoicingDashBoardStatsCardScss['dashboard-card']];

        if (darkMode) {
            cardClasses.push(InvoicingDashBoardStatsCardScss['dashboard-card-dark']);
        }

        const iconElement = getIconElement(icon, style);

        return (
            <Card
                onClick={() => this.setTileData(data)}
                type={'inner'}
                className={cardClasses.join(' ')}
                bordered={false}
                style={{
                    boxShadow: '0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12)',
                    cursor: 'pointer',
                }}
            >
                <Statistic
                    title={data.title}
                    value={data.value}
                    prefix={iconElement}
                />
            </Card>
        );
    }
}
